export enum ErrorCodes {
	cannotChangeSettingsForNonMemberProducts = 'canada-labeling-calculation-cannot-change-settings-for-non-member-products',
}
